import {MenuBadge} from 'platform/components';

export function toMenuBadge(count: number): MenuBadge {
  return {
    colorScheme: 'neutral',
    value: count,
  };
}
